// assets
import { IconBrandPython, IconNotebook, IconCode, IconChartBar, IconSettings, IconServer } from '@tabler/icons-react';

// constant
const icons = { IconBrandPython, IconNotebook, IconCode, IconChartBar, IconSettings, IconServer };

// ==============================|| JUPYTER LAB (Mở theo project từ Workspace) ||============================== //

const jupyter = {
    id: 'jupyter',
    title: 'Jupyter Lab',
    type: 'group',
    children: [
        {
            id: 'jupyter-module',
            title: 'Jupyter',
            type: 'collapse',
            icon: icons.IconBrandPython,
            children: [
                {
                    id: 'jupyter-dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/jupyter/dashboard',
                    breadcrumbs: false
                },
                {
                    id: 'notebooks',
                    title: 'Notebooks',
                    type: 'item',
                    url: '/jupyter/notebooks',
                    breadcrumbs: false
                },
                {
                    id: 'jupyter-servers',
                    title: 'Servers',
                    type: 'item',
                    url: '/jupyter/servers',
                    breadcrumbs: false
                },
                {
                    id: 'jupyter-settings',
                    title: 'Settings',
                    type: 'item',
                    url: '/jupyter/settings',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default jupyter;
